
namespace RioERP.Invoices {

    @Serenity.Decorators.registerClass()
    export class InvoicesDialog extends Serenity.EntityDialog<InvoicesRow, any> {
        protected getFormKey() { return InvoicesForm.formKey; }
        protected getIdProperty() { return InvoicesRow.idProperty; }
        protected getLocalTextPrefix() { return InvoicesRow.localTextPrefix; }
        protected getNameProperty() { return InvoicesRow.nameProperty; }
        protected getService() { return InvoicesService.baseUrl; }
        protected getDeletePermission() { return InvoicesRow.deletePermission; }
        protected getInsertPermission() { return InvoicesRow.insertPermission; }
        protected getUpdatePermission() { return InvoicesRow.updatePermission; }

        protected form = new InvoicesForm(this.idPrefix);

        private invoiceOrdersGrid: InvoiceOrdersGrid;
        private invoiceHsnGrid: InvoiceHsnGrid;
        //private productBookGrid1: ProductBooksGrid1;
        //private productBillingItemsGrid1: ProductBillingItemsGrid1;
        private loadedState: string;

        constructor() {
            super();

            this.invoiceOrdersGrid = new InvoiceOrdersGrid(this.byId("InvoiceOrdersGrid"));
            this.invoiceOrdersGrid.element.flexHeightOnly(1);

            this.invoiceHsnGrid = new InvoiceHsnGrid(this.byId("InvoiceHsnGrid"));
            this.invoiceHsnGrid.element.flexHeightOnly(1);

            //this.productBookGrid1 = new ProductBooksGrid1(this.byId("ProductBooksGrid1"));
            //this.productBookGrid1.element.flexHeightOnly(1);


            //this.productBillingItemsGrid1 = new ProductBillingItemsGrid1(this.byId("ProductBillingItemsGrid1"));
            //this.productBillingItemsGrid1.element.flexHeightOnly(1);


        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        loadResponse(data) {
            super.loadResponse(data);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'InvoiceOrders', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'InvoiceHsn', this.isNewOrDeleted());

            //Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBooks', this.isNewOrDeleted());

            //Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBillingItems', this.isNewOrDeleted());

            //
            if (this.form.FreezeData.value == true) {
                Serenity.TabsExtensions.setDisabled(this.tabs, 'InvoiceOrders', true);

                Serenity.TabsExtensions.setDisabled(this.tabs, 'InvoiceHsn', true);
            }
            this.loadedState = this.getSaveState();
        }

        loadEntity(entity: InvoicesRow) {
            super.loadEntity(entity);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'InvoiceOrders', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'InvoiceHsn', this.isNewOrDeleted());

            //Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBooks', this.isNewOrDeleted());
            //Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBillingItems', this.isNewOrDeleted());

            this.invoiceOrdersGrid.InvoiceId = entity.Id;
            this.invoiceHsnGrid.InvoiceId = entity.Id;
            //this.productBookGrid1.ProductId = entity.Id;
            //this.productBillingItemsGrid1.ProductId = entity.Id;
            if (this.isNewOrDeleted() == true) {
                this.element.find(".bg-olive").toggle(false);
            }
            else {
                if (this.form.FreezeData.value != true) {
                    this.element.find(".bg-olive").toggle(true);
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                    this.element.find(".bg-olive").toggle(false);

                }
            }
            if (Authorization.hasPermission("Administration:Security")) {
                Serenity.EditorUtils.setReadonly(this.form.Invoicenumber.element, false);
            }
            else
                Serenity.EditorUtils.setReadonly(this.form.Invoicenumber.element, true);

            
        }

        protected updateInterface(): void {

            super.updateInterface();          
            this.deleteButton.toggle(false);
            this.saveAndCloseButton.toggle(false);
            this.applyChangesButton.toggle(false);
           
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.invoiceOrdersGrid.InvoiceId = this.entityId;
            this.invoiceHsnGrid.InvoiceId = this.entityId;
            //this.productBookGrid1.ProductId = this.entityId;
            //this.productBillingItemsGrid1.ProductId = this.entityId;
            //Passing discount to OrderProduct Editor
            //   this.form.OrderProducts.discount = this.form.DiscountPer.value;
        }

        protected validateBeforeSave() {
            var isValidate = super.validateForm();
            if (isValidate) {
                isValidate = super.validateBeforeSave();
            }
            //if (this.form.OrderProducts.rowCount() == 0) {
            //    Q.alert("At least one Product is mandatory for Order.");
            //    return false;
            //}
            return isValidate;
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            
            buttons.push({
                title: Q.text('Freeze Invoice'),
                cssClass: 'bg-olive',
                icon: 'fa fa-lock text-green',
                onClick: () => {
                    Q.confirm("Are you sure You want to Freeze Invoice and its Order(s)?", () => {
                        this.form.FreezeData.value = true;
                        this.saveAndCloseButton.click();
                    });

                }
            });
           
            
          
            return buttons;
        }
    }
}